import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AssistanceProgramComponent from '../components/assistance-program';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectListItems } from '../../../../../redux/library/selector';
import { settings } from '../../../../../redux/settings/actions';
import { deepCopy } from '../../../../../common/services/common.service';
import UploadFiles from '../../../../../models/UploadFile';
import { selectTermsLibrariesListItems } from '../../../../../redux/terms-libraries/selector';
import { selectAssistanceProgramsQueryItems } from '../../../../../redux/assistance-programs/selector';
import { assistancePrograms } from '../../../../../redux/assistance-programs/action';
import { termsLibraries } from '../../../../../redux/terms-libraries/action';
import PageLoader from '../../../../../components/PageLoader';


let currentChange: any = {}
const ManagementAssistanceProgram = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const { getUploadFiles } = useAppSelector(selectCurrent)
    const libraryData = useSelector(selectListItems)
    const termsLibraryListItems = useSelector(selectTermsLibrariesListItems)
    const queryItems = useSelector(selectAssistanceProgramsQueryItems)

    const [selectedAssistancePlans, setSelectedAssistancePlans] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedAssistancePrograms,
        setSelectedAssistancePrograms
    ] = useState<any>([])
    const [
        programPlanImageIndex,
        setProgramPlanImageIndex
    ] = useState<any>([])
    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])
    const [
        openFile,
        setOpenFile
    ] = useState<any>([]);

    const fetchQueryById = () => {
        dispatch(assistancePrograms.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/assistance-programs/query`, entity: 'assistancePrograms', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedAssistancePrograms({ ...selectedAssistancePrograms, [field]: event })
    }

    const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(mediaFiles);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setMediaFiles(items);
    }

    useEffect(
        () => {
            dispatch(termsLibraries.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/list`, entity: 'termsLibraries', jsonData: {}

            }))

            if (parmas?.id > 0) {
                fetchQueryById()
                const localSelectedProgramPlans = addNewProgramPlansRow({ selectedProgramPlansArg: selectedAssistancePlans });
                setSelectedAssistancePlans(localSelectedProgramPlans)
            } else {
                const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
                setMediaFiles(localSelectedMedia)
                const localSelectedProgramPlans = addNewProgramPlansRow({ selectedProgramPlansArg: selectedAssistancePlans });
                setSelectedAssistancePlans(localSelectedProgramPlans)
                setIsLoading(false)
            }

        },
        []
    )



    useEffect(
        () => {

            if (isQuery) {
                setSelectedAssistancePrograms(queryItems?.result?.items)
                const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
                setMediaFiles(localSelectedMedia)
                const planItemsData: any = queryItems?.result?.items?.AssistanceProgram.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        Name: item?.Name,
                        VehicleType: item?.VehicleType,
                        ProgramDuration: item?.ProgramDuration,
                        CoverageRadius: item?.CoverageRadius,
                        NumberOfServiceAnnually: item?.NumberOfServiceAnnually,
                        IsAssistanceOverPhone: item?.IsAssistanceOverPhone,
                        Towing: item?.Towing,
                        IsOnSiteMinorRepairs: item?.IsOnSiteMinorRepairs,
                        IsFlatTyreAssistance: item?.IsFlatTyreAssistance,
                        IsLockedKey: item?.IsLockedKey,
                        IsBatterySupport: item?.IsBatterySupport,
                        IsCityRouteAndMapGuidance: item?.IsCityRouteAndMapGuidance,
                        BikeTaxiBenefits: item?.BikeTaxiBenefits,
                        IsRelayOnMessages: item?.IsRelayOnMessages,
                        IsMedicalCordination: item?.IsMedicalCordination,
                        IsAccidentalLegalCoordination: item?.IsAccidentalLegalCoordination,
                        IsDedicatedHelpline: item?.IsDedicatedHelpline,
                        CoolingPeriod: item?.CoolingPeriod,
                        Price: item?.Price
                    }
                    return itemData
                })
                const localSelectedProgramPlans = addNewProgramPlansRow({ selectedProgramPlansArg: planItemsData });
                setSelectedAssistancePlans(localSelectedProgramPlans)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )

        selectedAssistancePlans.splice(selectedAssistancePlans.length - 1, 1);
        const ProgramPlanItemsData: any = selectedAssistancePlans.map((item: any) => {
            const itemData = {
                Id: item?.Id || 0,
                Name: item?.Name,
                VehicleType: item?.VehicleType,
                ProgramDuration: item?.ProgramDuration,
                CoverageRadius: item?.CoverageRadius,
                NumberOfServiceAnnually: item?.NumberOfServiceAnnually,
                IsAssistanceOverPhone: item?.IsAssistanceOverPhone,
                Towing: item?.Towing,
                IsOnSiteMinorRepairs: item?.IsOnSiteMinorRepairs,
                IsFlatTyreAssistance: item?.IsFlatTyreAssistance,
                IsLockedKey: item?.IsLockedKey,
                IsBatterySupport: item?.IsBatterySupport,
                IsCityRouteAndMapGuidance: item?.IsCityRouteAndMapGuidance,
                BikeTaxiBenefits: item?.BikeTaxiBenefits,
                IsRelayOnMessages: item?.IsRelayOnMessages,
                IsMedicalCordination: item?.IsMedicalCordination,
                IsAccidentalLegalCoordination: item?.IsAccidentalLegalCoordination,
                IsDedicatedHelpline: item?.IsDedicatedHelpline,
                CoolingPeriod: item?.CoolingPeriod,
                Price: item?.Price
            }
            return itemData
        })
        const assistanceProgramData = {
            "Id": 8,
            "Name": selectedAssistancePrograms?.Name,
            "Remarks": selectedAssistancePrograms?.Remarks,
            "Description": selectedAssistancePrograms?.Description,
            "IsActive": selectedAssistancePrograms?.IsActive,
            "StartDateUtc": selectedAssistancePrograms?.StartDateUtc,
            "EndDateUtc": selectedAssistancePrograms?.EndDateUtc,
            "DisplayOrder": selectedAssistancePrograms?.DisplayOrder,
            "TermsLibraryId": selectedAssistancePrograms?.TermsLibraryId,
            "IsAlwaysEnabled": selectedAssistancePrograms?.IsAlwaysEnabled,
            "AssistanceProgram": ProgramPlanItemsData,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []
            }
        }
        if (parmas?.id > 0) {
            dispatch(assistancePrograms.update({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/assistance-programs`, entity: 'assistancePrograms', jsonData: {

                    Records: [
                        assistanceProgramData

                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            dispatch(assistancePrograms.create({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/assistance-programs`, entity: 'assistancePrograms', jsonData: {

                    Records: [
                        assistanceProgramData
                    ]

                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/policy/assistance-programs')
    }

    //Media File Logic
    const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
        const localSelectedmedia = deepCopy(selectedMediaFilesArg)
        const newsSelectedMedia = {
            Id: 0,
            FileTypeId: 0,
            OwnerId: parmas?.id,
            OwnerTypeId: 171,
            FileMappingURL: ''
        }
        if (localSelectedmedia.length === 0 ||
            localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
        ) {
            localSelectedmedia?.push(newsSelectedMedia)
        }

        return localSelectedmedia
    }
    const setMediaInfo = async () => {
        let localSelectedMedia = deepCopy(mediaFiles)
        localSelectedMedia.splice(
            currentChange.idx,
            1,
            { ...localSelectedMedia[currentChange.idx] }
        );
        localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
        currentChange.field = 'FileTypeIdDONE'
        setMediaFiles(localSelectedMedia)
    }
    const changeImage = (idx: number, templateField: any, fileType: any) => {
        setProgramPlanImageIndex(idx)
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenFile({
            currentFileSrc: mediaFiles[idx][templateField],
            folder: 'Assistanceprogram',
            type: fileType
        })
    }
    const handleSubmit = (data: any) => {

        mediaFiles[programPlanImageIndex].FileMappingURL = data
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
    }
    const handleClose = () => {
        dispatch(settings.set({ getUploadFiles: 'close' }))

    }
    useEffect(
        () => {
            if (currentChange.field === 'FileTypeId') {
                setMediaInfo()
            }
        },
        [mediaFiles]
    )

    //Program plan logic

    const addNewProgramPlansRow = ({ selectedProgramPlansArg }: any) => {
        const localSelectedProgramPlans = deepCopy(selectedProgramPlansArg);
        const newProgramPlan = {
            Id: 0,
            Name: '',
            ProgramDuration: '',
            CoverageRadius: '',
            NumberOfServiceAnnually: 0,
            Towing: '',
            BikeTaxiBenefits: '',
            CoolingPeriod: '',
            Price: 0
        };
        if (
            localSelectedProgramPlans.length === 0 ||
            localSelectedProgramPlans[localSelectedProgramPlans?.length - 1]
                ?.Name !== '' ||
            localSelectedProgramPlans[localSelectedProgramPlans?.length - 1]?.ProgramDuration !== ''
        ) {
            localSelectedProgramPlans?.push(newProgramPlan);
        }

        return localSelectedProgramPlans;
    };
    const handleFormPlanIItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(selectedAssistancePlans); // deep copy of items
        let item = items[idx]; // deep copy of item to be edited
        item = { ...item, [field]: value }; // updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx };
        setSelectedAssistancePlans(items);
    };
    const setAssistancePlansInfo = async () => {
        let localAssistancePlans = deepCopy(selectedAssistancePlans);
        localAssistancePlans.splice(currentChange.idx, 1, {
            ...localAssistancePlans[currentChange.idx],
        });
        localAssistancePlans = addNewProgramPlansRow({
            selectedProgramPlansArg: localAssistancePlans,
        });
        currentChange.field = 'NameDONE';
        setSelectedAssistancePlans(localAssistancePlans);
    };
    useEffect(() => {
        if (currentChange.field === 'Name') {
            setAssistancePlansInfo();
        }
    }, [selectedAssistancePlans]);




    const handleDelete = (productItem: any, index: any) => {

        const updatedItems = [...selectedAssistancePlans];  // Create a copy of the array
        updatedItems.splice(index, 1);  // Remove the item at the given index
        setSelectedAssistancePlans(updatedItems)
    }

    return (
        <>
            {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                folder={openFile?.folder}
                handleClose={handleClose}
                handleFilesSubmit={handleSubmit}
                type={openFile?.type}
                ownerId={parmas?.id}
            />}
            {isLoading ? <PageLoader /> :


                <AssistanceProgramComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedAssistancePrograms={selectedAssistancePrograms}
                    vehicleTypes={libraryData?.result?.VehicleType}
                    termsLibraries={termsLibraryListItems?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    handleFormMediaItemChange={handleFormMediaItemChange}
                    mediaFiles={mediaFiles}
                    changeImage={changeImage}
                    id={parmas?.id}
                    fileTypes={libraryData?.result?.FileType}
                    selectedAssistancePlans={selectedAssistancePlans}
                    handleFormPlanIItemChange={handleFormPlanIItemChange}
                    handleDelete={handleDelete}
                />
            }

        </>
    )

}

export default ManagementAssistanceProgram;